import React, { useEffect, useRef, useState } from "react";
import axios from "../axios/axiosUmbraco";
import { useSelector } from "react-redux";
import styled from 'styled-components';
import YouTubePlayer from "./YouTubePlayer";
import { Link } from "react-router-dom";
import Popup from "reactjs-popup";
import CustomPopUp from "./CustomPopUp";
import { getFileName } from "../helper/getFileName";
import { convertYouTubeURL } from "../helper/convertYouTubeURL";
const BaseURL = process.env.REACT_APP_BASE_URL;
const fetch = process.env.REACT_APP_HOME_PAGE_FIRST_SECTION_ID;
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;



export default function VideoSlider() {
  const videoRef = useRef();
  const { currentLanguage } = useSelector(
    (state) => state.studBookSlice
  );
  const [sliderItems, setSliderItems] = useState([{
    name: "",
    image: '',
    isExternalLink: false,
    sliderLink: '',
    isImage: true,
    subTitle: "",
    title: "", videoLink: ''
  }]);
  const [total, setTotal] = useState(0);
  const [yvideoID, setvideoID] = useState('')

  
  function getCurrentLanguageUmbraco() {
    // Replace this with your logic to retrieve the current language
    // For example, you can retrieve it from localStorage or from a state variable
    const lang = localStorage.getItem("eahsLang") ?? "en";
    if (lang == "en") return 'en-US';
    else return 'ar-AE'; // Defaulting to English for demonstration
  }

  useEffect(() => {
    async function getdata() {
      const umbraco = await axios.get(`/umbraco/delivery/api/v1/content?fetch=${fetch}&skip=0&take=1000`, {
        headers: {
          "accept-language": getCurrentLanguageUmbraco(),

        }
      })
      const formattedData = umbraco.data?.items.map((item) => ({
        name: item.name,
        image: item.properties?.image ? item.properties?.image[0]?.url : '',
        bg: item.properties?.itemBackground ? item.properties?.itemBackground[0]?.url : '',
        isExternalLink: item.properties?.isExternalLink ? true : false,
        publishForWeb: item.properties?.publishForWeb ? true : false,
        sliderLink: item.properties?.sliderLink ? item.properties?.sliderLink : '',
        isImage: item.properties?.sliderType ? true : false,
        subTitle: item.properties?.subTitle ? item.properties?.subTitle : '',
        sort: item.properties?.sort ? item.properties?.sort : 1,
        title: item.properties?.title ? item.properties?.title : '',
        videoLink: item.properties?.videoLink ? convertYouTubeURL(item.properties?.videoLink) : ''
      }));
      const filterdData = formattedData.filter(item => item.publishForWeb);
      setTotal(filterdData?.length ?? 0)
      const sortedData = filterdData.sort((a, b) => a.sort - b.sort);
      setSliderItems(sortedData);
    }
    getdata();

  }, [currentLanguage])



  return (
    <>
      {total > 0 &&
        <div className="">
          <div className="">
            <div id="video_section" className="carousel slide" data-ride="carousel" data-bs-ride="carousel">
              {total > 1 &&
                <>
                  <ol className="carousel-indicators video_section_class ">
                    {Array.from({ length: total }).map((_, index) => (
                      <li
                        key={index}
                        data-target="#video_section"
                        data-bs-target="#video_section"
                        data-slide-to={index}
                        data-bs-slide-to={index}
                        className={index === 0 ? "active" : ""}
                      ></li>
                    ))}
                  </ol>
                  {/* <div class="carousel-indicators video_section_class justRotate">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
              </div> */}
                </>
              }


              <div className="carousel-inner">
                {sliderItems.map((item, index) => (
                  <div className={index === 0 ? "carousel-item item active " : "carousel-item item"} style={{ backgroundImage: `url(${MediaBaseURL}${item.bg})`, backgroundSize: 'cover', backgroundRepeat: 'repeat' }}>
                    {/* check if it is video or Image item */}
                    <div className="container mobile-extra-padding" >
                      {item.isImage ?
                        <>
                          {/* image */}
                          {item.sliderLink == '' ?
                            <div className="position-relative" style={{ aspectRatio: '344/113', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <img
                                // className="first_slider_img"
                                autoPlay
                                alt={getFileName(item?.image)}
                                muted
                                src={`${MediaBaseURL}${item.image}`}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = `${BaseURL}/assets/img/horseauction.png`;
                                }}
                                style={{ width: '100%' }}
                              />
                              {!!item?.videoLink &&
                                <CustomPopUp
                                  trigger={
                                    <div className="position-absolute top-0 bottom-0 start-0 end-0 d-flex ms-2 justify-content-start pt-5  align-items-center" style={{ marginTop: '1rem' }}>
                                      <button className="btn btn-outline-danger   rounded-pill px-5" style={{ right: 0, fontSize: 12 }} ><i className=" fa-solid fa-play"></i></button>
                                    </div>
                                  }
                                  content={
                                    <YouTubePlayer key={item.videoLink} videoId={item.videoLink} />
                                  }
                                />
                              }
                            </div>
                            :
                            <Link className="position-relative" to={item.sliderLink} target={item.isExternalLink ? "_blank" : '_self'}>
                              <img
                                // className="first_slider_img"
                                autoPlay
                                alt={getFileName(item?.image)}
                                muted
                                src={`${MediaBaseURL}${item.image}`}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = `${BaseURL}/assets/img/horseauction.png`;
                                }}
                                style={{ width: '100%' }}
                              />
                              {!!item?.videoLink &&
                                <CustomPopUp
                                  trigger={
                                    <div className="position-absolute top-0 bottom-0 start-0 end-0 ms-2 d-flex justify-content-start pt-5  align-items-center" style={{ marginTop: '1rem' }}>
                                      <button className="btn btn-outline-danger   rounded-pill px-5" style={{ right: 0, fontSize: 12 }} ><i className=" fa-solid fa-play"></i></button>
                                    </div>
                                  }
                                  content={
                                    <YouTubePlayer key={item.videoLink} videoId={item.videoLink} />
                                  }
                                />
                              }
                            </Link>
                          }

                          {/* <div className="video_overlay"></div> */}
                          <div className="carousel-caption first_slider_caption">
                            {item.sliderLink == '' ?
                              <>
                                <h3 className="video_title font-64 color-eahsred">
                                  {item.title}
                                </h3>
                                <p className="video_subtitle font-24 white-icon fontweight600">
                                  {item.subTitle}
                                </p>
                              </>
                              :
                              <a href={item.sliderLink} target={item.isExternalLink ? "_blank" : '_self'}>
                                <h3 className="video_title font-64 color-eahsred">
                                  {item.title}
                                </h3>
                                <p className="video_subtitle font-24 white-icon fontweight600">
                                  {item.subTitle}
                                </p>
                              </a>}
                          </div>

                        </>
                        :
                        <>
                          {/* video */}
                          <div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {!!item.videoLink &&
                              <YouTubePlayer key={item.videoLink} videoId={item.videoLink} />
                            }

                          </div>

                          {/* <div className="video_overlay"></div> */}
                          <div className="carousel-caption first_slider_caption">
                            {item.sliderLink == '' ?
                              <>
                                <h3
                                  className="video_title font-64 color-eahsred"
                                >
                                  {item.title}
                                </h3>
                                <p
                                  className="video_subtitle font-24 white-icon fontweight600"
                                >
                                  {item.subTitle}
                                </p>
                              </> :
                              <>
                                <a href={item.sliderLink} target={item.isExternalLink ? "_blank" : '_self'}>
                                  <h3
                                    className="video_title font-64 color-eahsred"
                                  >
                                    {item.title}
                                  </h3>
                                  <p
                                    className="video_subtitle font-24 white-icon fontweight600"
                                  >
                                    {item.subTitle}
                                  </p>
                                </a>
                              </>
                            }


                            <br />
                            <br />
                          </div>
                        </>
                      }
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
}